module.exports = __webpack_public_path__ + "assets/images/voice-feature@3x-a84ce7a0a97e91e99fba3a0461fe03cf.png";